import React, { useState, useEffect, useCallback } from 'react';
import { Theme } from '../../enums/theme.enum';
import { ThemeContext } from './theme.context';

export default function ThemeContextWrapper(props: React.PropsWithChildren<{}>) {
  const [theme, setTheme] = useState(Theme.LIGHT);

  const changeTheme = useCallback((theme: Theme) => {
    setTheme(theme);
  }, []);

  useEffect(() => {
    ['light-theme', 'dark-theme', 'aqua-magenta-theme'].forEach(theme => document.body.classList.remove(theme));
    document.body.classList.add(theme + "-theme");
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
}